import * as api from '../coOpApi';
import { call, put, takeEvery } from 'redux-saga/effects';
import { coOpActionCreators, CoOpActionKeys, FetchCoOpDealerRequests } from '..';
import { ICoOpRequestApiResponse } from '../coOpInterfaces';
import { uiActionCreators } from '../../ui';

function* fetchCoOpDealerRequestsSaga(action: FetchCoOpDealerRequests) {
  yield put(uiActionCreators.toggleLoading('coOpDealerRequests'));
  const response: ICoOpRequestApiResponse = yield call(api.fetchDealerCoOpRequests, action.payload.accountNum);

  yield put(coOpActionCreators.setRequests(response.requests));
  yield put(coOpActionCreators.setSalesDistrictBudgets(response.salesDistrictBudgets));

  yield put(uiActionCreators.toggleLoading('coOpDealerRequests'));
}

export function* watchFetchCoOpDealerRequests() {
  yield takeEvery(CoOpActionKeys.FETCH_COOP_DEALER_REQUESTS, fetchCoOpDealerRequestsSaga);
}
